// import type {RenewalDetails} from './RenewalStatusTable';
// import Data from './Data/Data.json'

// export const data: RenewalDetails[] = Data;

import RenewalDetails from './RenewalStatusTable';
import Data from './Data/Data.json';

export const data = Data;
